export default __webpack_public_path__ + "static/media/pic5.9eaa94a0.png";